var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.278,
    height: 24.277,
    viewBox: "0 0 24.278 24.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_facebook",
    d: "M25.388,4H6.89A2.891,2.891,0,0,0,4,6.89v18.5a2.891,2.891,0,0,0,2.89,2.89h18.5a2.891,2.891,0,0,0,2.89-2.89V6.89A2.891,2.891,0,0,0,25.388,4Zm-2.312,8.67H21.92c-1.237,0-1.734.289-1.734,1.156v1.734h2.89l-.578,2.89H20.186v8.67H17.3v-8.67H14.983v-2.89H17.3V13.827c0-2.312,1.156-4.046,3.468-4.046a3.566,3.566,0,0,1,2.312.578Z",
    transform: "translate(-4 -4)",
    fill: "#002b5a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFacebook);
export default __webpack_public_path__ + "static/media/homeFacebook.63bb0cd18e2488c63ed2b2aba93ece8d.svg";
export { ForwardRef as ReactComponent };